var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOther = function SvgOther(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 49 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.006 20.93h-16.96c-2.64 0-4.69-2.1-4.808-4.593-.031-.675.126-1.346.374-1.975L9.32 7.475A9.742 9.742 0 0 1 18.377 1.3H39.79a4.82 4.82 0 0 1 4.812 4.827v9.975a4.826 4.826 0 0 1-3.716 4.701"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M36.844 16.756h-4.308a1.073 1.073 0 0 1-1.071-1.075v-9.13c0-.593.48-1.074 1.07-1.074h4.309c.592 0 1.071.48 1.071 1.074v9.13c0 .594-.48 1.075-1.071 1.075z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.392 5.477H21.56v6.735H7.457m9.02-6.735v6.735m14.987 2.292H6.614m41.386 0H37.913M29.05 19.46v-2.706h10.83v2.705m-11.872 2.824v-2.705h12.88v2.705"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M26.754 24.999h15.303v-2.706H26.754v2.706zm-9.396-2.034A2.032 2.032 0 0 1 15.33 25a2.032 2.032 0 0 1-2.03-2.035c0-1.125.91-2.035 2.03-2.035 1.12 0 2.028.91 2.028 2.035z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M48 13.117v2.847M4.813 8.602v16.2m1.556-15.04-1.564 1.63M3.496 9.219l1.232 1.067m3.817-.83a3.834 3.834 0 0 0-.7-1.524 3.38 3.38 0 0 0-1.143-4.287c.068-.202.113-.414.113-.637A2.004 2.004 0 0 0 4.813 1c-1.104 0-2 .9-2 2.008 0 .223.045.435.111.637a3.386 3.386 0 0 0-1.143 4.287A3.813 3.813 0 0 0 1 10.246a3.82 3.82 0 0 0 3.813 3.825c.79 0 1.524-.24 2.132-.653m26.118-2.914v1.605"
  })));
};
export default SvgOther;